import { CompanionInPublicTransportType } from "../../companion-transport-types/CompanionInPublicTransportType";

export default interface CompanionInPublicTransportOption {
  readonly companionInPublicTransportType?: CompanionInPublicTransportType | null;
  readonly ticketPrice?: number | null;
}

export const CompanionInPublicTransportOptionInital: CompanionInPublicTransportOption = {
  companionInPublicTransportType: null,
  ticketPrice: null,
};
